import { useSelector } from 'react-redux';

import { getPortalUtilityLength } from 'src/shared/app/base/portal/notification/selector/portalRegistrationSelector';

export default function usePortalRegistrationLength(
  portalKey: string,
): Record<string, any> {
  return useSelector(getPortalUtilityLength(portalKey));
}
